import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const homeNavItems = [
    { label: 'Nasıl Çalışır', id: 'how-it-works' },
    { label: 'Tasarımlar', id: 'inspiration' },
    { label: 'İletişim', id: 'cta' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-luxury-black/95 backdrop-blur-md border-b border-luxury-border'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/1dc01291-9518-472c-8814-2fd5a6290899.png"
            alt="Sara Kuyumculuk Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {isHome ? (
            <>
              {homeNavItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className="text-white/70 hover:text-gold transition-colors duration-300 font-sans text-xs tracking-luxury uppercase whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </button>
              ))}
            </>
          ) : (
            <>
              <Link
                to="/"
                className="text-white/70 hover:text-gold transition-colors duration-300 font-sans text-xs tracking-luxury uppercase whitespace-nowrap"
              >
                Ana Sayfa
              </Link>
            </>
          )}
          <Link
            to="/hakkimizda"
            className="text-white/70 hover:text-gold transition-colors duration-300 font-sans text-xs tracking-luxury uppercase whitespace-nowrap"
          >
            Hakkımızda
          </Link>
          <Link
            to="/sss"
            className="text-white/70 hover:text-gold transition-colors duration-300 font-sans text-xs tracking-luxury uppercase whitespace-nowrap"
          >
            SSS
          </Link>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="btn-gold px-6 py-2.5 text-xs rounded-sm whitespace-nowrap"
          >
            WhatsApp
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white cursor-pointer"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-luxury-black/98 border-t border-luxury-border px-6 py-6 flex flex-col gap-6">
          {isHome ? (
            <>
              {homeNavItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className="text-white/70 hover:text-gold transition-colors text-sm tracking-wide uppercase text-left cursor-pointer"
                >
                  {item.label}
                </button>
              ))}
            </>
          ) : (
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="text-white/70 hover:text-gold transition-colors text-sm tracking-wide uppercase"
            >
              Ana Sayfa
            </Link>
          )}
          <Link
            to="/hakkimizda"
            onClick={() => setMenuOpen(false)}
            className="text-white/70 hover:text-gold transition-colors text-sm tracking-wide uppercase"
          >
            Hakkımızda
          </Link>
          <Link
            to="/sss"
            onClick={() => setMenuOpen(false)}
            className="text-white/70 hover:text-gold transition-colors text-sm tracking-wide uppercase"
          >
            SSS
          </Link>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="btn-gold px-6 py-3 text-xs text-center rounded-sm"
          >
            WhatsApp&apos;tan Yaz
          </a>
        </div>
      )}
    </nav>
  );
}
